import "../assets/styles/views/change-password.scss";
import { useOutletContext, NavLink } from "react-router-dom";
import { change_password, password_recovery } from "../utils/endpoints";
import PasswordField from "../components/PasswordField";
import { useState } from "react";

export default function ChangePassword() {
  const [context, setContext] = useOutletContext();
  const [password_strength, setPasswordStrength] = useState(0);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!!context.session) {
      const obj = {
        email: context.session.email,
        currentPassword: e.target.old_password.value,
        newPassword: e.target.new_password.value,
        tenantGuid: process.env.REACT_APP_GUID,
      };

      if (obj.newPassword !== e.target.confirm_password.value)
        context.openMessage("danger", "Le due password non corrispondono.");
      else {
        let response = await context.httpRequest("post", change_password, obj);
        if (response.result) {
          context.openMessage("success", "La password è stata cambiata");
          context.navigateUrl("/account");
        }
      }
    }
  };

  const handlePasswordTyping = (e) => {
    const password = e.target.value;
    let strength = 0;
    if (/[a-z]/g.test(password)) strength++;
    if (/[A-Z]/g.test(password)) strength++;
    if (/[1-9]/g.test(password)) strength++;
    if (/.{8,}/g.test(password)) strength++;

    setPasswordStrength(strength);
  };

  return (
    <section className="change-password mt-md-5 w-100 main-panel p-3">
      <div className="d-flex align-items-center">
        <h1 className="m-0">Modifica password</h1>
      </div>
      <form onSubmit={(e) => handleSubmit(e)}>
        <label className="d-block mt-3">VECCHIA PASSWORD</label>
        <PasswordField
          name="old_password"
          required={true}
          check_format={false}
        />
        <label className="d-block mt-3">NUOVA PASSWORD</label>
        <PasswordField
          name="new_password"
          required={true}
          check_format={true}
          onChange={(e) => handlePasswordTyping(e)}
        />

        <div className="d-flex align-items-center mt-2">
          <small>Sicurezza password</small>
          <meter
            className="w-50 ms-auto"
            min="0"
            max="4"
            low="1"
            high="3"
            optimum="4"
            value={password_strength}
          ></meter>
        </div>
        <small className="mt-2 d-block">
          Minimo 8 caratteri, almeno un carattere maiuscolo, almeno un carattere
          minuscolo ed almeno un numero.
        </small>

        <label className="d-block mt-3">CONFERMA PASSWORD</label>
        <PasswordField
          name="confirm_password"
          required={true}
          check_format={true}
        />
        <button className="mt-3 p-3 w-100 q8-blue-button" type="submit">
          CONFERMA
        </button>
      </form>
    </section>
  );
}
